import React from 'react'

type FileSignatureProps = React.SVGProps<SVGSVGElement> & {
  width?: number
  height?: number
  fill?: string
}

export const FileSignature = ({
  width = 19,
  height = 16,
  fill = '#5A45DF',
  ...props
}: FileSignatureProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.71802 0L7.71802 0L7.71802 4C7.71802 4.5625 8.15552 5 8.71802 5L12.718 5L12.718 6.375L9.74927 9.34375C9.49927 9.59375 9.31177 9.90625 9.21802 10.2812L8.74927 12.1562C8.68677 12.4375 8.68677 12.75 8.78052 13H8.49927L8.37427 12.75C8.15552 12.2812 7.68677 12 7.21802 12C6.90552 12 6.59302 12.125 6.37427 12.3125L5.99927 11.125C5.90552 10.75 5.56177 10.5 5.21802 10.5C4.84302 10.5 4.49927 10.75 4.40552 11.125L3.93677 12.6562C3.87427 12.875 3.68677 13 3.46802 13H3.21802C2.93677 13 2.71802 13.25 2.71802 13.5C2.71802 13.7812 2.93677 14 3.21802 14H3.46802C4.12427 14 4.71802 13.5938 4.90552 12.9375L5.21802 11.9062L5.71802 13.6562C5.78052 13.8438 5.96802 14 6.15552 14C6.37427 14.0312 6.56177 13.9375 6.65552 13.75L6.93677 13.1875C6.96802 13.0937 7.09302 13 7.21802 13C7.31177 13 7.43677 13.0937 7.46802 13.1875L7.74927 13.75C7.84302 13.9062 7.99927 14 8.21802 14H10.218C10.218 14 10.2493 14 10.2805 14C10.3743 14 10.468 14 10.5618 13.9687L12.4368 13.5C12.5305 13.4687 12.6243 13.4375 12.718 13.4062V14C12.718 15.125 11.8118 16 10.718 16L2.71802 16C1.59302 16 0.718018 15.125 0.718018 14L0.718018 2C0.718018 0.90625 1.59302 0 2.71802 0ZM8.71802 0L12.718 4L8.71802 4V0ZM17.8743 4.375L18.343 4.84375C18.8118 5.3125 18.8118 6.125 18.343 6.59375L17.4055 7.53125L15.1868 5.3125L16.1243 4.375C16.593 3.90625 17.4055 3.90625 17.8743 4.375ZM10.4368 10.0312L14.4993 6L16.718 8.21875L12.6555 12.25C12.5305 12.4062 12.3743 12.4687 12.218 12.5312L10.3118 13C10.1555 13.0312 9.96802 13 9.84302 12.875C9.71802 12.75 9.68677 12.5625 9.71802 12.375L10.1868 10.5C10.218 10.3437 10.3118 10.1875 10.4368 10.0312Z"
        fill={fill}
      />
    </svg>
  )
}

export default FileSignature
